export var UserRole;
(function (UserRole) {
    UserRole["CompanyAdministrator"] = "Company Administrator";
    UserRole["Administrator"] = "Administrator";
    UserRole["User"] = "User";
})(UserRole || (UserRole = {}));
// Role → accessor → permission layer, shared by the API (session-scoped, plus
// resource-org matching) and the web app (route/affordance gating), so the role
// tiers can't drift between the two.
/** Ethisphere Administrator — a platform-wide admin with no respondent-side rights. */
export function isEthisphereAdmin(roles) {
    return roles?.includes(UserRole.Administrator) ?? false;
}
/** Org Admin (Company Administrator) — the org's own admin. */
export function isOrgAdmin(roles) {
    return roles?.includes(UserRole.CompanyAdministrator) ?? false;
}
/** Org View Only — read-only member of their own org. */
export function isOrgUser(roles) {
    return roles?.includes(UserRole.User) ?? false;
}
/**
 * The roles permitted to EDIT an assessment: only the org's own admin (Company
 * Administrator). Org View Only is read-only.
 */
export function canEditAssessment(roles) {
    return isOrgAdmin(roles);
}
/**
 * The roles permitted to VIEW an assessment: the org's own roles — Org View Only
 * views read-only alongside the Company Administrator.
 */
export function canViewAssessment(roles) {
    return isOrgAdmin(roles) || isOrgUser(roles);
}
/**
 * An Ethisphere Administrator holding no org role. A session carrying both an
 * Ethisphere and an org role is excluded — that org-level access is legitimate.
 */
export function isEthisphereAdminOnly(roles) {
    return isEthisphereAdmin(roles) && !canViewAssessment(roles);
}
//# sourceMappingURL=auth.js.map